import './BrokerModal.scss'

import React, {Component} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import ConfirmButton from 'common/views/atoms/ConfirmButton/ConfirmButton'
import { editAgentExperienceLevel } from 'broker/redux/account'

class ConfirmEditAgentExperience extends Component {
  handleClick = () => {
    const { agent_experience_level, agent_id, dispatch, handleHide } = this.props
    dispatch(editAgentExperienceLevel(agent_experience_level, agent_id))
    .then(handleHide)
  }

  render() {
    const { agent_name } = this.props
    return (
      <Modal className="BrokerModal" show={this.props.show}>
        <Modal.Header>
          <Modal.Title>Edit Agent Experience Level?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text">
            Are you sure you want to edit { agent_name }&#39;s experience level? You won&#39;t be able to change it back.
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="pull-right" onClick={this.props.handleHide}>Cancel</Button>
          <div className="pull-right btn-pad-right"><ConfirmButton onSubmit={this.handleClick} onFinish={this.props.handleHide} timeouts={2000} initialText="Yes" pendingText="Sending" completeText="Sent" /></div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const ConfirmEditAgentExperienceModal = connectModal({ name: 'ConfirmEditAgentExperienceModal', destroyOnHide: true })(ConfirmEditAgentExperience)

export default ConfirmEditAgentExperienceModal
